import { DEFAULT_MODEL_ID } from '../../services/AIProviderService';
import type { VolumeLevel } from '../../components/chat/WorkItemVolumeMenu';

export enum GenerationFormStoreActionTypes {
  AddNotesHistory = 'ADD_NOTES_HISTORY',
  SetSelectedModel = 'SET_SELECTED_MODEL',
  SetWorkItemVolume = 'SET_WORK_ITEM_VOLUME'
}

export type GenerationFormState = {
  generationNotesHistory: string[];
  selectedModelId: string;
  workItemVolume: VolumeLevel;
};

export const initialGenerationFormState: GenerationFormState = {
  generationNotesHistory: [],
  selectedModelId: DEFAULT_MODEL_ID,
  workItemVolume: 'medium'
};

export type GenerationFormStorePayload = {
  [GenerationFormStoreActionTypes.AddNotesHistory]: string;
  [GenerationFormStoreActionTypes.SetSelectedModel]: string;
  [GenerationFormStoreActionTypes.SetWorkItemVolume]: VolumeLevel;
};
